import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./AirRefund.css";

const ELIGIBLE_FLIGHTS = [
  { flight: "LY 315 TLV → LHR", date: "Mar 5", delay: "3h 20m", status: "Eligible", amount: "€400" },
  { flight: "BA 166 LHR → JFK", date: "Feb 18", delay: "4h 45m", status: "Claimed", amount: "€600" },
  { flight: "EL 452 FCO → TLV", date: "Jan 29", delay: "2h 10m", status: "Not eligible", amount: "—" },
];

export default function AirRefund() {
  const [showClaim, setShowClaim] = useState(false);

  return (
    <div className="airrefund-page">
      <Link to="/benefits" className="back-link">← Benefits</Link>

      <section className="airrefund-hero">
        <h1 className="airrefund-title">AirRefund</h1>
        <p className="airrefund-subtitle">Get compensated for flight delays and cancellations. Up to €600 per flight under EU261.</p>
      </section>

      <div className="airrefund-stats-row">
        <div className="airrefund-stat">
          <span className="airrefund-stat-value">€600</span>
          <span className="airrefund-stat-label">Max claim</span>
        </div>
        <div className="airrefund-stat">
          <span className="airrefund-stat-value">3h+</span>
          <span className="airrefund-stat-label">Delay threshold</span>
        </div>
        <div className="airrefund-stat">
          <span className="airrefund-stat-value">Free</span>
          <span className="airrefund-stat-label">No win no fee</span>
        </div>
      </div>

      <section className="airrefund-flights">
        <h3 className="section-title">Recent Flights</h3>
        {ELIGIBLE_FLIGHTS.map((f, i) => (
          <div key={i} className="airrefund-flight-item">
            <div className="airrefund-flight-info">
              <span className="airrefund-flight-route">{f.flight}</span>
              <span className="airrefund-flight-meta">{f.date} · {f.delay} delay</span>
            </div>
            <div className="airrefund-flight-right">
              <span className="airrefund-flight-amount">{f.amount}</span>
              <span className={`airrefund-flight-status ${f.status.toLowerCase().replace(/ /g, "-")}`}>
                {f.status}
              </span>
            </div>
          </div>
        ))}
      </section>

      <section className="airrefund-how">
        <h3 className="section-title">How It Works</h3>
        <div className="airrefund-steps">
          <div className="airrefund-step">
            <span className="airrefund-step-num">1</span>
            <div>
              <span className="airrefund-step-title">Check eligibility</span>
              <span className="airrefund-step-text">Flights departing from or arriving in the EU with 3h+ delay</span>
            </div>
          </div>
          <div className="airrefund-step">
            <span className="airrefund-step-num">2</span>
            <div>
              <span className="airrefund-step-title">File a claim</span>
              <span className="airrefund-step-text">Submit your boarding pass and flight details</span>
            </div>
          </div>
          <div className="airrefund-step">
            <span className="airrefund-step-num">3</span>
            <div>
              <span className="airrefund-step-title">We handle everything</span>
              <span className="airrefund-step-text">AirRefund negotiates with the airline on your behalf</span>
            </div>
          </div>
          <div className="airrefund-step">
            <span className="airrefund-step-num">4</span>
            <div>
              <span className="airrefund-step-title">Get paid</span>
              <span className="airrefund-step-text">Compensation deposited to your eToro account</span>
            </div>
          </div>
        </div>
      </section>

      <button className="airrefund-claim-btn" onClick={() => setShowClaim(true)} type="button">
        File a Claim →
      </button>

      {showClaim && (
        <div className="airrefund-modal-overlay">
          <div className="airrefund-modal">
            <h2>File a Claim</h2>
            <p className="airrefund-modal-text">Enter your flight details to check eligibility and submit a compensation claim.</p>
            <div className="airrefund-form">
              <input type="text" placeholder="Flight number (e.g. LY 315)" className="airrefund-input" />
              <input type="date" className="airrefund-input" />
              <button className="airrefund-submit-btn" type="button" onClick={() => setShowClaim(false)}>
                Check Eligibility
              </button>
            </div>
            <button className="airrefund-modal-close" onClick={() => setShowClaim(false)} type="button">Cancel</button>
          </div>
        </div>
      )}

      <div className="airrefund-close-wrap">
        <Link to="/benefits" className="airrefund-close-btn">Close</Link>
      </div>

      <footer className="powered-by">Powered by Visa</footer>
    </div>
  );
}
